// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as React from "react";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as MeterKeg from "../../components/MeterKeg/MeterKeg.bs.jsx";
import * as TapKegOn from "./TapKegOn.bs.jsx";
import * as TapAddNew from "./TapAddNew.bs.jsx";
import * as TapRename from "./TapRename.bs.jsx";
import * as Reactfire from "reactfire";
import * as ButtonMenu from "../../components/ButtonMenu/ButtonMenu.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as SectionWithHeader from "../../components/SectionWithHeader/SectionWithHeader.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as DialogConfirmation from "../../components/DialogConfirmation/DialogConfirmation.bs.jsx";
import TapsSettingModuleCss from "./TapsSetting.module.css";

let classes = TapsSettingModuleCss;

function TapsSetting$ConfirmDeleteTap(props) {
  return <DialogConfirmation.make
    heading={"Smazat pípu ❓"}
    onConfirm={props.onConfirm}
    onDismiss={props.onDismiss}
    visible={true}
  >
    <div>
      {"Potvzením smažete pípu: "}
      <b>
        {props.tapName}
      </b>
    </div>
  </DialogConfirmation.make>;
}

let ConfirmDeleteTap = {
  make: TapsSetting$ConfirmDeleteTap
};

function TapsSetting(props) {
  let untappedChargedKegs = props.untappedChargedKegs;
  let tappedChargedKegs = props.tappedChargedKegs;
  let placeId = props.placeId;
  let place = props.place;
  let firestore = Reactfire.useFirestore();
  let match = React.useState(() => "Hidden");
  let setDialog = match[1];
  let dialogState = match[0];
  let hideDialog = param => setDialog(param => "Hidden");
  let hasKegsToTap = untappedChargedKegs.length !== 0;
  let tappedKegsById = React.useMemo(() => Object.fromEntries(tappedChargedKegs.map(keg => [
    Db.getUid(keg),
    keg
  ])), [tappedChargedKegs]);
  let sortedTapEntries = React.useMemo(() => {
    let tapsEntries = Object.entries(place.taps);
    tapsEntries.sort((a, b) => a[0].localeCompare(b[0]));
    return tapsEntries;
  }, [place.taps]);
  let tapsCount = sortedTapEntries.length;
  let tmp;
  if (typeof dialogState !== "object") {
    tmp = dialogState === "Hidden" ? null : <TapAddNew.make
        existingNames={Object.keys(place.taps)}
        onDismiss={hideDialog}
        onSubmit={async values => {
          Db.Place.tapAdd(firestore, placeId, values.name);
          return setDialog(param => "Hidden");
        }}
      />;
  } else {
    switch (dialogState.TAG) {
      case "RenameTap" :
        let tapName = dialogState._0;
        tmp = <TapRename.make
          existingNames={Object.keys(place.taps)}
          initialName={tapName}
          onDismiss={hideDialog}
          onSubmit={values => {
            Db.Place.tapRename(firestore, placeId, tapName, values.name);
            setDialog(param => "Hidden");
          }}
        />;
        break;
      case "DeleteTap" :
        let tapName$1 = dialogState._0;
        tmp = <ConfirmDeleteTap.make
          onConfirm={() => {
            Db.Place.tapDelete(firestore, placeId, tapName$1);
          }}
          onDismiss={hideDialog}
          tapName={tapName$1}
        />;
        break;
      case "TapKegOn" :
        let tapName$2 = dialogState._0;
        tmp = <TapKegOn.make
          onDismiss={hideDialog}
          onSubmit={values => {
            Db.Place.tapKegOn(firestore, placeId, tapName$2, values.keg);
            setDialog(param => "Hidden");
          }}
          tapName={tapName$2}
          untappedChargedKegs={untappedChargedKegs}
        />;
        break;
    }
  }
  return <SectionWithHeader.make
    buttonsSlot={<button
      className={Styles.button.base}
      type={"button"}
      onClick={param => setDialog(param => "AddTap")}
    >
      {"Přidat pípu"}
    </button>}
    headerId={"taps_setting"}
    headerSlot={"Pípy"}
  >
    <ul
      className={classes.list}
    >
      {sortedTapEntries.map(param => {
        let tapName = param[0];
        let tappedKeg = Stdlib_Option.flatMap(Primitive_option.fromNull(param[1]), kegRef => tappedKegsById[kegRef.id]);
        return <li
          key={tapName} >
          <div>
            <div>
              {tapName}
              {Stdlib_Option.mapOr(tappedKeg, null, keg => <div
                className={classes.tappedBeer}
              >
                <span>
                  {keg.serialFormatted}
                </span>
                {` ` + keg.beer}
              </div>)}
            </div>
            {tappedKeg !== undefined ? <button
                className={Styles.button.variantDanger}
                type={"button"}
                onClick={param => {
                  Db.Place.tapKegOff(firestore, placeId, tapName);
                }}
              >
                {"Odrazit"}
              </button> : <button
                className={Styles.button.variantPrimary}
                disabled={!hasKegsToTap}
                type={"button"}
                onClick={param => setDialog(param => ({
                  TAG: "TapKegOn",
                  _0: tapName
                }))}
              >
                {"Narazit"}
              </button>}
            <ButtonMenu.make
              className={Styles.button.iconOnly}
              menuItems={[
                {
                  label: "Přejmenovat",
                  onClick: param => setDialog(param => ({
                    TAG: "RenameTap",
                    _0: tapName
                  }))
                },
                {
                  disabled: tappedKeg !== undefined || tapsCount < 2,
                  label: "Smazat",
                  onClick: param => setDialog(param => ({
                    TAG: "DeleteTap",
                    _0: tapName
                  }))
                }
              ]}
              title={"další akce"}
            >
              {"⋯"}
            </ButtonMenu.make>
          </div>
          {tappedKeg !== undefined ? <MeterKeg.make
              ariaLabel={`Sud ` + tappedKeg.serialFormatted + ` pivo ` + tappedKeg.beer + ` zbývající hladina`}
              keg={tappedKeg}
            /> : null}
        </li>;
      })}
    </ul>
    {tmp}
  </SectionWithHeader.make>;
}

let make = TapsSetting;

export {
  classes,
  ConfirmDeleteTap,
  make,
}
/* classes Not a pure module */
